import { render } from "./ExpertLoadingDots.vue?vue&type=template&id=10765e88&scoped=true"
import script from "./ExpertLoadingDots.vue?vue&type=script&lang=js"
export * from "./ExpertLoadingDots.vue?vue&type=script&lang=js"

import "./ExpertLoadingDots.vue?vue&type=style&index=0&id=10765e88&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10765e88"]])

export default __exports__